query referenciaGcpjEncerramentoSelect {
    data: referenciasGcpjsEncerramentos(order: [{nome: ASC}]) {
        value: codigo
        label: nome
    }
}